import store from "@/core/services/store";

const PANEL_IMPLICIT_PERMISSIONS = {
  2: [
    "dashboard.view",
    "contacts.view",
    "contacts.create",
    "contacts.update",
    "contacts.archive",
    "projects.view",
    "projects.create",
    "projects.update",
    "agencies.view",
    "agencies.create",
    "agencies.update",
    "developers.view",
    "developers.create",
    "developers.update",
    "listings.view",
    "listings.create",
    "listings.update",
    "listings.archive"
  ],
  3: [
    "dashboard.view",
    "contacts.view",
    "contacts.create",
    "contacts.update",
    "contacts.archive",
    "projects.view",
    "listings.view",
    "agencies.view",
    "agencies.create",
    "agencies.update"
  ],
  4: [
    "dashboard.view",
    "contacts.view",
    "contacts.create",
    "contacts.update",
    "contacts.archive",
    "projects.view"
  ],
  5: [
    "dashboard.view",
    "contacts.view",
    "contacts.create",
    "contacts.update",
    "contacts.archive",
    "projects.view",
    "listings.view"
  ]
};

function panelUserHasPermission(type, permission) {
  const allowed = PANEL_IMPLICIT_PERMISSIONS[type];
  return Array.isArray(allowed) && allowed.includes(permission);
}

const AuthService = {
  hasPermission(permission) {
    if (permission === "allow") {
      return true;
    }

    if (store.state.auth.permissions.length !== 0) {
      const hasStored = store.state.auth.permissions.some(spec => spec === permission);
      if (hasStored) {
        return true;
      }
    }

    const userType = store.state.auth.user && store.state.auth.user.type;
    if (userType !== undefined && userType !== null) {
      return panelUserHasPermission(parseInt(userType, 10), permission);
    }

    return false;
  }
};

export default AuthService;
